
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexkn5_T3hdG4shigPYGHpmBwx2iVNRvfYwlDctuUAs3DgMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/login/index.tsx?macro=true";
import { default as kapita_45p1_bxHpdsJmW2QVkrMDF2f5sIw0daK5_3dj8k7CzT8Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/login/kapita.tsx?macro=true";
import { default as index0Buse5RaFKgcM3Hb_7LofrAYZiDao9ZwyOahwxRrKEYMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/verifyEmail/index.tsx?macro=true";
import { default as indexgMXQZxuHKBL4_45O8BoGeHW5Lh8aJqTzwVDEzctmrDChYMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/createAccount/index.tsx?macro=true";
import { default as index16q0ZpIxZkfdvnZvxxePIakr3T6tXvAV6PNwLYnUZ08Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/resetPassword/index.tsx?macro=true";
import { default as indexcYqdenZ17Xj6GfRvuo5B9zAfokojXm7ZOi6D_cazO0UMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/account-exists/index.tsx?macro=true";
import { default as kapitaQfD0X4_H2xA6Q3C_dTS0YW2xTsbhQaywGGLq8cM50n8Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/resetPassword/kapita.tsx?macro=true";
import { default as indexiYsQrkFIbKaFyFpQ_5QZS48xOuVbHLEm_45PNHd0OI_z8Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/emailVerificationCallback/index.tsx?macro=true";
import { default as authPvd5lPbtRc_45w65dg5U0LG_Clm4wCwoz9NCb_45ix1jDSgMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth.tsx?macro=true";
import { default as gdprTuJ1nVBSihW5JSX29FgBft8_tTBsaJditSZwxRQ14IYMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/gdpr.tsx?macro=true";
import { default as index1WylswcGdD8BJrOag_Sm7cv0icFbR5lf_VJtQ7MLh6MMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/news/index.tsx?macro=true";
import { default as index45m5JDoIrADCaSC9JlwaEtwYUh_2NNbPqLD2zoQRhYgMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/files/index.tsx?macro=true";
import { default as index4DvuJRZiyHAVkLMpfimsrwUetupl_A5KYmBqTzL_RjIMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/logos/index.tsx?macro=true";
import { default as indexdyTVKVfCuo_ybnF5kk8cb_455bAmyNlaCI7GjdJHvU8dsMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/users/index.tsx?macro=true";
import { default as indexXSLtLXVs1CABBqRQ1vQh1UBft6LUL9kdfTQ3ruDfpHgMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/assets/index.tsx?macro=true";
import { default as index2tjx5mDTb3S2ueoQCnqNOjs32i95l6_f3vy7_4qT9msMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/invites/index.tsx?macro=true";
import { default as indexxPySt0NvzzzDL6datZVBTRCa_2AgEPx1t_45b9Kw4phRIMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/metrics/index.tsx?macro=true";
import { default as index0066HC1vrmxYEFVGTLzuSkmpyNmiWwqj7Jj7DhUMZi8Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/scraper/index.tsx?macro=true";
import { default as indexUfXZrtwl6kAPN8RDQjp_Vldzk83Za0L_45jwZOUfSBGBMMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/finsquid/index.tsx?macro=true";
import { default as indexwPk_45QbkjtnlpQx0tOxXn_450dy9l7GKfbrUYkTZS9Hut4Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/keycodes/index.tsx?macro=true";
import { default as index3wZ2d3QrhIMS6q62t1sequYO_45JOJPjycmHFA9r8EnL0Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/waitlist/index.tsx?macro=true";
import { default as indexQdeMDLOyxwmNU4_45HQaI8iqowxNVVSeU06CDgLfb_45Ei4Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/ai-agents/index.tsx?macro=true";
import { default as indexlC2_9zeLzYu5M9AtsXH4AUYKlktZpIEB2izacXBUgs4Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/companies/index.tsx?macro=true";
import { default as indexzlcZ3s4Ywl3xyTJbJr7dIaTvGo8Xa1_HqQHKjCMwHfYMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/csvImport/index.tsx?macro=true";
import { default as indexMnaLMeS6Y_45KO_zmxLS5Tn3lAoWS3wWZb7r9S_45lFI2rgMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/dashboard/index.tsx?macro=true";
import { default as indexpDwYiLehSvxy61C4myNYk2ncSSXTKcI_AdOQY3gfDDIMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/referrals/index.tsx?macro=true";
import { default as index3_45e_vGxieQ8WVysiM384odbQUxunTXDw4nuALDAA20UMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/snapshots/index.tsx?macro=true";
import { default as indextPZBSKJHfJTZC_45b9rKqjpO9kXlyuCSka2SI7IqKCFl8Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/fx-history/index.tsx?macro=true";
import { default as indexI7yZhN57mmwSY5Oy1jwaPWxX1o7sCXNZF3K7G_45hMkBYMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/users/[id]/index.tsx?macro=true";
import { default as index9yBQvqu0RdIkaE7eoxHPpj1G8ImsGqnb8t6eYQVu2bEMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/investments/index.tsx?macro=true";
import { default as indexbK3_mRRWrotTMvysgtDxFz4r4fJSCy6NIljkcXZHyLgMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/notifications/index.tsx?macro=true";
import { default as indexta4rqcUWHxgFkr2S8Z0oZjvoaYSzEVaEs8_45zHZG5PJgMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/opportunities/index.tsx?macro=true";
import { default as indexsXzzxIELNfxc8_45y6fs_Qn9d5tmJiUBb4QYNRYaynJjAMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/company-profiles/index.tsx?macro=true";
import { default as index5m0bOA6a63QFpCXExUUQVxjVb7xkwOkOgJ0r3FfqeB8Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/user-capabilities/index.tsx?macro=true";
import { default as indexjgWne2WWAnct6qyuS_3AY8g_D2gZtuqosjMKSpFjoo8Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/application-events/index.tsx?macro=true";
import { default as indexmT_450_jS0Y1ZWHJQUfQLVIJdliTqzwJGl3PSiPd_45FUJcMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/opportunity-inquires/index.tsx?macro=true";
import { default as index6Qh425i0cZp6VIbhtWt6FwsPA04Zcnjb_BDLQXLfVKkMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/opportunity-interests/index.tsx?macro=true";
import { default as superadmindOhh0U_45nrM8WXi4T2PaoQh4uAIXFLM2AS02zKzDiqOcMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin.tsx?macro=true";
import { default as indexFA1u6AAKoYcOe1i8s5F8n7sGqG88Jq4Vls7_45RhEHL_45YMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/404/index.tsx?macro=true";
import { default as formQANpJnkkejJDOHIh2j_45qn10m2fLPea6WG19OWI97aOQMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/form.tsx?macro=true";
import { default as menuy7oVz8nVz_MlDfXzNcRsi9JZziHk_45VHMq8YOsivG_45rEMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/menu.tsx?macro=true";
import { default as index94gSiXTl6e9dHWl_45MkmSGsd6tvtPBDj2qR0ogR_IloIMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/index.tsx?macro=true";
import { default as flanksJinIh3yHEOGsa0oCdVci8V4UG_45R3Gycvz_BDVZ894qUMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/flanks.tsx?macro=true";
import { default as indexZLNUh_koDXFi4LktlkONjJJ0S0WG9FXouUeGYmx5f48Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/ir-documents/index.tsx?macro=true";
import { default as indexuM5pd96XO_XIJp1esnCp5j8wDhXkwKYC7wQf8k6dY1AMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/share-ledger/index.tsx?macro=true";
import { default as index_45tEaMTUc483dZwH1dFwvOqt4woKrS9hA4uJ3FEJos5IMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/shareholders/index.tsx?macro=true";
import { default as indexCYP2W8Mlt9T3nvZDNEqFgv_45C3LcwE5dxprE_45F5qE_NsMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/communication/index.tsx?macro=true";
import { default as indexC34zllN_45yHiwsXdf3wkS0Y_45chYYsjOdMNVvUXx3tHywMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/communication/[communicationId]/index.tsx?macro=true";
import { default as _91companyId_93yBN7UO9ulIjgVmaHDT1qT0r7XLkuZhX3mhyqXyEp1coMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId].tsx?macro=true";
import { default as investor_45relationsP7tl8Xgk9Qq8PQejD4i7szDY_DnpbeT8PyyGIO1OA2YMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations.tsx?macro=true";
import { default as indexpPcPz0G_45igZXXB4Pfsk5MscSJhl1MQgUMnGHTJnq7pQMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/newsfeed/index.tsx?macro=true";
import { default as indexF7RyEKkV3JIonByxXSzQ0U9lcETk4Drn_dOu1lOrjFEMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/index.tsx?macro=true";
import { default as indexHvLB3BzLwOdWlklZG7BTFj83xQQgCy1YN0yEARvlW_450Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/documents/index.tsx?macro=true";
import { default as fileuploadePoYR6xtQ4vtLHJHOyZztZKC52pfqj_Bd2s4y5Zq_45FYMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/fileupload.tsx?macro=true";
import { default as index654ppk5mmuKRAKULd8u8JzCCPw6wa3jqWnD_45hYeApZMMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(dashboard)/index.tsx?macro=true";
import { default as only_45desktopnSX14m_kdmwW7Mb0sR6yF9EMY5CICrcKGVYLQEWwVNwMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/only-desktop.tsx?macro=true";
import { default as notificationsrSEEhWT2Nh_Pe5Vw095nT0wetp8dYjrUg24Yf2U9AFQMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/notifications.tsx?macro=true";
import { default as indexH0EyqTFTBj09Z_45h0BCEm18DoqcNTzIXoyK8wDytUg04Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/opportunities/index.tsx?macro=true";
import { default as indexqHHg1ix_45_Qut3e3l7AqbU7g_459IacRjNV_HAEDRO_45S7wMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/files/index.tsx?macro=true";
import { default as indexmvd__mCpCTvUkJ5MkhtrvQ9a9kdIuLS6WjQcd6zCyMQMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/investments/index.tsx?macro=true";
import { default as indexWSpwZRAsFv5vW5R2z1EJE_45LYi6bhG1ybodKIjq1WhMUMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/liabilities/index.tsx?macro=true";
import { default as indexiL57AutrVVM4R3mLfo2fz4GPEXQ2wdmMDSATidxO23YMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/investments/[id]/index.tsx?macro=true";
import { default as indexouwRXwGeWJuIJmmt5tH4jT0Fly50oq600d38nrAEUuIMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/liabilities/[id]/index.tsx?macro=true";
import { default as indexum9_45J_WCoYcDCcPycBO1D9LF_S5Xki4tF3_45TvWKWM9gMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/investments/[id]/communication/index.tsx?macro=true";
import { default as indexk9gDfqBn3UkzMi82yV2lodgFZMCNrvj_45aAY5pFlolS0Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/investments/[id]/communication/[communicationId]/index.tsx?macro=true";
import { default as portfolioocMTU6yPW5CuoNaG8guglKJ_4R03rvDb2J_ElM5cJ4UMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio.tsx?macro=true";
import { default as indexmbJ2NT0CQJZLagi8RIBcgNFpzduVNnjkJCkOWV24Jp8Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/invites/index.tsx?macro=true";
import { default as indexrkWvSxljdrEJ69pn_aByVkN8K0XEPD1fJz42qArexTQMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/profile/index.tsx?macro=true";
import { default as indexMnOvNiwMglIw5HtmXqNexIR53LO6WH1zKg80lfGyuFYMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/security/index.tsx?macro=true";
import { default as indexVba0TN_IUX_EQHf1naPaalYADJMFzKqJ_K5m28tljGUMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/opportunities/[id]/index.tsx?macro=true";
import { default as indexar7XvJJCCj_457dXxugUcUbQRSk0t6HoC18TuzJGL6zmcMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/snapshots/index.tsx?macro=true";
import { default as indexuaCm7zaIxBxrcTjm0aaMeUVSf3bQGwtwEUhxpROUMx4Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/integrations/index.tsx?macro=true";
import { default as index2Uouy5ETjgfNcFSu9xvMDQ7IH_45VcklPtyTeuO5ySCUsMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/integrations/[id]/index.tsx?macro=true";
import { default as indexqJowuk3dHU1QJ8D6zSwfmfKqhV2E5uRZAMLSaKEH9BMMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/company/[id]/roles/index.tsx?macro=true";
import { default as indexHfIArpVFJuR3jei5d9AS0xeCZcbPsHRCfnqbzDiemC8Meta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/company/[id]/profile/index.tsx?macro=true";
import { default as indexbfYEXyYygzEFczTlRfW91luN_45yXoaKbjy9SUINogB2AMeta } from "/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/company/[id]/ir-information/index.tsx?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    meta: authPvd5lPbtRc_45w65dg5U0LG_Clm4wCwoz9NCb_45ix1jDSgMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth.tsx"),
    children: [
  {
    name: "auth-login",
    path: "login",
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/login/index.tsx")
  },
  {
    name: "auth-login-kapita",
    path: "login/kapita",
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/login/kapita.tsx")
  },
  {
    name: "auth-verifyEmail",
    path: "verifyEmail",
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/verifyEmail/index.tsx")
  },
  {
    name: "auth-createAccount",
    path: "createAccount",
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/createAccount/index.tsx")
  },
  {
    name: "auth-resetPassword",
    path: "resetPassword",
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/resetPassword/index.tsx")
  },
  {
    name: "auth-account-exists",
    path: "account-exists",
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/account-exists/index.tsx")
  },
  {
    name: "auth-resetPassword-kapita",
    path: "resetPassword/kapita",
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/resetPassword/kapita.tsx")
  },
  {
    name: "auth-emailVerificationCallback",
    path: "emailVerificationCallback",
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/auth/emailVerificationCallback/index.tsx")
  }
]
  },
  {
    name: "superadmin",
    path: "/superadmin",
    meta: superadmindOhh0U_45nrM8WXi4T2PaoQh4uAIXFLM2AS02zKzDiqOcMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin.tsx"),
    children: [
  {
    name: "superadmin-gdpr",
    path: "gdpr",
    meta: gdprTuJ1nVBSihW5JSX29FgBft8_tTBsaJditSZwxRQ14IYMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/gdpr.tsx")
  },
  {
    name: "superadmin-news",
    path: "news",
    meta: index1WylswcGdD8BJrOag_Sm7cv0icFbR5lf_VJtQ7MLh6MMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/news/index.tsx")
  },
  {
    name: "superadmin-files",
    path: "files",
    meta: index45m5JDoIrADCaSC9JlwaEtwYUh_2NNbPqLD2zoQRhYgMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/files/index.tsx")
  },
  {
    name: "Logos",
    path: "logos",
    meta: index4DvuJRZiyHAVkLMpfimsrwUetupl_A5KYmBqTzL_RjIMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/logos/index.tsx")
  },
  {
    name: "superadmin-users",
    path: "users",
    meta: indexdyTVKVfCuo_ybnF5kk8cb_455bAmyNlaCI7GjdJHvU8dsMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/users/index.tsx")
  },
  {
    name: "superadmin-assets",
    path: "assets",
    meta: indexXSLtLXVs1CABBqRQ1vQh1UBft6LUL9kdfTQ3ruDfpHgMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/assets/index.tsx")
  },
  {
    name: "superadmin-invites",
    path: "invites",
    meta: index2tjx5mDTb3S2ueoQCnqNOjs32i95l6_f3vy7_4qT9msMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/invites/index.tsx")
  },
  {
    name: "superadmin-metrics",
    path: "metrics",
    meta: indexxPySt0NvzzzDL6datZVBTRCa_2AgEPx1t_45b9Kw4phRIMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/metrics/index.tsx")
  },
  {
    name: "Scraper",
    path: "scraper",
    meta: index0066HC1vrmxYEFVGTLzuSkmpyNmiWwqj7Jj7DhUMZi8Meta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/scraper/index.tsx")
  },
  {
    name: "superadmin-finsquid",
    path: "finsquid",
    meta: indexUfXZrtwl6kAPN8RDQjp_Vldzk83Za0L_45jwZOUfSBGBMMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/finsquid/index.tsx")
  },
  {
    name: "superadmin-keycodes",
    path: "keycodes",
    meta: indexwPk_45QbkjtnlpQx0tOxXn_450dy9l7GKfbrUYkTZS9Hut4Meta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/keycodes/index.tsx")
  },
  {
    name: "superadmin-waitlist",
    path: "waitlist",
    meta: index3wZ2d3QrhIMS6q62t1sequYO_45JOJPjycmHFA9r8EnL0Meta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/waitlist/index.tsx")
  },
  {
    name: "superadmin-ai-agents",
    path: "ai-agents",
    meta: indexQdeMDLOyxwmNU4_45HQaI8iqowxNVVSeU06CDgLfb_45Ei4Meta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/ai-agents/index.tsx")
  },
  {
    name: "superadmin-companies",
    path: "companies",
    meta: indexlC2_9zeLzYu5M9AtsXH4AUYKlktZpIEB2izacXBUgs4Meta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/companies/index.tsx")
  },
  {
    name: "csvImport",
    path: "csvImport",
    meta: indexzlcZ3s4Ywl3xyTJbJr7dIaTvGo8Xa1_HqQHKjCMwHfYMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/csvImport/index.tsx")
  },
  {
    name: "dashboard",
    path: "dashboard",
    meta: indexMnaLMeS6Y_45KO_zmxLS5Tn3lAoWS3wWZb7r9S_45lFI2rgMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/dashboard/index.tsx")
  },
  {
    name: "superadmin-referrals",
    path: "referrals",
    meta: indexpDwYiLehSvxy61C4myNYk2ncSSXTKcI_AdOQY3gfDDIMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/referrals/index.tsx")
  },
  {
    name: "superadmin-snapshots",
    path: "snapshots",
    meta: index3_45e_vGxieQ8WVysiM384odbQUxunTXDw4nuALDAA20UMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/snapshots/index.tsx")
  },
  {
    name: "superadmin-fx-history",
    path: "fx-history",
    meta: indextPZBSKJHfJTZC_45b9rKqjpO9kXlyuCSka2SI7IqKCFl8Meta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/fx-history/index.tsx")
  },
  {
    name: "superadmin-user",
    path: "users/:id()",
    meta: indexI7yZhN57mmwSY5Oy1jwaPWxX1o7sCXNZF3K7G_45hMkBYMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/users/[id]/index.tsx")
  },
  {
    name: "superadmin-investments",
    path: "investments",
    meta: index9yBQvqu0RdIkaE7eoxHPpj1G8ImsGqnb8t6eYQVu2bEMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/investments/index.tsx")
  },
  {
    name: "superadmin-notifications",
    path: "notifications",
    meta: indexbK3_mRRWrotTMvysgtDxFz4r4fJSCy6NIljkcXZHyLgMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/notifications/index.tsx")
  },
  {
    name: "superadmin-opportunities",
    path: "opportunities",
    meta: indexta4rqcUWHxgFkr2S8Z0oZjvoaYSzEVaEs8_45zHZG5PJgMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/opportunities/index.tsx")
  },
  {
    name: "superadmin-company-profiles",
    path: "company-profiles",
    meta: indexsXzzxIELNfxc8_45y6fs_Qn9d5tmJiUBb4QYNRYaynJjAMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/company-profiles/index.tsx")
  },
  {
    name: "user-capabilities",
    path: "user-capabilities",
    meta: index5m0bOA6a63QFpCXExUUQVxjVb7xkwOkOgJ0r3FfqeB8Meta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/user-capabilities/index.tsx")
  },
  {
    name: "superadmin-application-events",
    path: "application-events",
    meta: indexjgWne2WWAnct6qyuS_3AY8g_D2gZtuqosjMKSpFjoo8Meta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/application-events/index.tsx")
  },
  {
    name: "superadmin-opportunity-inquires",
    path: "opportunity-inquires",
    meta: indexmT_450_jS0Y1ZWHJQUfQLVIJdliTqzwJGl3PSiPd_45FUJcMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/opportunity-inquires/index.tsx")
  },
  {
    name: "superadmin-opportunity-interests",
    path: "opportunity-interests",
    meta: index6Qh425i0cZp6VIbhtWt6FwsPA04Zcnjb_BDLQXLfVKkMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/superadmin/opportunity-interests/index.tsx")
  }
]
  },
  {
    name: "404",
    path: "/404",
    meta: {"groups":["app"]},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/404/index.tsx")
  },
  {
    name: "Debug Form",
    path: "/debug/form",
    meta: { ...(formQANpJnkkejJDOHIh2j_45qn10m2fLPea6WG19OWI97aOQMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/form.tsx")
  },
  {
    name: "Debug Menu",
    path: "/debug/menu",
    meta: { ...(menuy7oVz8nVz_MlDfXzNcRsi9JZziHk_45VHMq8YOsivG_45rEMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/menu.tsx")
  },
  {
    name: "Debug",
    path: "/debug",
    meta: { ...(index94gSiXTl6e9dHWl_45MkmSGsd6tvtPBDj2qR0ogR_IloIMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/index.tsx")
  },
  {
    name: "Debug Flanks",
    path: "/debug/flanks",
    meta: { ...(flanksJinIh3yHEOGsa0oCdVci8V4UG_45R3Gycvz_BDVZ894qUMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/flanks.tsx")
  },
  {
    name: "Investor Relations",
    path: "/investor-relations",
    meta: investor_45relationsP7tl8Xgk9Qq8PQejD4i7szDY_DnpbeT8PyyGIO1OA2YMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations.tsx"),
    children: [
  {
    name: "investor-relations-companyId",
    path: ":companyId()",
    meta: _91companyId_93yBN7UO9ulIjgVmaHDT1qT0r7XLkuZhX3mhyqXyEp1coMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId].tsx"),
    children: [
  {
    name: "ir-documents",
    path: "ir-documents",
    meta: indexZLNUh_koDXFi4LktlkONjJJ0S0WG9FXouUeGYmx5f48Meta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/ir-documents/index.tsx")
  },
  {
    name: "investor-relations-companyId-share-ledger",
    path: "share-ledger",
    meta: indexuM5pd96XO_XIJp1esnCp5j8wDhXkwKYC7wQf8k6dY1AMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/share-ledger/index.tsx")
  },
  {
    name: "Cap Table",
    path: "shareholders",
    meta: index_45tEaMTUc483dZwH1dFwvOqt4woKrS9hA4uJ3FEJos5IMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/shareholders/index.tsx")
  },
  {
    name: "Investor Updates",
    path: "communication",
    meta: indexCYP2W8Mlt9T3nvZDNEqFgv_45C3LcwE5dxprE_45F5qE_NsMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/communication/index.tsx")
  },
  {
    name: "communication-detail",
    path: "communication/:communicationId()",
    meta: indexC34zllN_45yHiwsXdf3wkS0Y_45chYYsjOdMNVvUXx3tHywMeta || {},
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/investor-relations/[companyId]/communication/[communicationId]/index.tsx")
  }
]
  }
]
  },
  {
    name: "newsfeed",
    path: "/newsfeed",
    meta: { ...(indexpPcPz0G_45igZXXB4Pfsk5MscSJhl1MQgUMnGHTJnq7pQMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/newsfeed/index.tsx")
  },
  {
    name: "Settings",
    path: "/settings",
    meta: { ...(indexF7RyEKkV3JIonByxXSzQ0U9lcETk4Drn_dOu1lOrjFEMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/index.tsx")
  },
  {
    name: "Documents",
    path: "/documents",
    meta: { ...(indexHvLB3BzLwOdWlklZG7BTFj83xQQgCy1YN0yEARvlW_450Meta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/documents/index.tsx")
  },
  {
    name: "Debug Fileupload",
    path: "/debug/fileupload",
    meta: { ...(fileuploadePoYR6xtQ4vtLHJHOyZztZKC52pfqj_Bd2s4y5Zq_45FYMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/fileupload.tsx")
  },
  {
    name: "Dashboard",
    path: "/",
    meta: { ...(index654ppk5mmuKRAKULd8u8JzCCPw6wa3jqWnD_45hYeApZMMeta || {}), ...{"groups":["app","dashboard"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(dashboard)/index.tsx")
  },
  {
    name: "Debug Menu",
    path: "/debug/only-desktop",
    meta: { ...(only_45desktopnSX14m_kdmwW7Mb0sR6yF9EMY5CICrcKGVYLQEWwVNwMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/only-desktop.tsx")
  },
  {
    name: "Debug Notifications",
    path: "/debug/notifications",
    meta: { ...(notificationsrSEEhWT2Nh_Pe5Vw095nT0wetp8dYjrUg24Yf2U9AFQMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/debug/notifications.tsx")
  },
  {
    name: "Opportunities",
    path: "/opportunities",
    meta: { ...(indexH0EyqTFTBj09Z_45h0BCEm18DoqcNTzIXoyK8wDytUg04Meta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/opportunities/index.tsx")
  },
  {
    name: "Files",
    path: "/settings/files",
    meta: { ...(indexqHHg1ix_45_Qut3e3l7AqbU7g_459IacRjNV_HAEDRO_45S7wMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/files/index.tsx")
  },
  {
    name: "Portfolio",
    path: "/portfolio",
    meta: { ...(portfolioocMTU6yPW5CuoNaG8guglKJ_4R03rvDb2J_ElM5cJ4UMeta || {}), ...{"groups":["app","portfolio"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio.tsx"),
    children: [
  {
    name: "portfolio-investments",
    path: "investments",
    props: true,
    meta: { ...(indexmvd__mCpCTvUkJ5MkhtrvQ9a9kdIuLS6WjQcd6zCyMQMeta || {}), ...{"groups":["app","portfolio"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/investments/index.tsx")
  },
  {
    name: "portfolio-liabilities",
    path: "liabilities",
    props: true,
    meta: { ...(indexWSpwZRAsFv5vW5R2z1EJE_45LYi6bhG1ybodKIjq1WhMUMeta || {}), ...{"groups":["app","portfolio"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/liabilities/index.tsx")
  },
  {
    name: "portfolio-investments-id",
    path: "investments/:id()",
    props: true,
    meta: { ...(indexiL57AutrVVM4R3mLfo2fz4GPEXQ2wdmMDSATidxO23YMeta || {}), ...{"groups":["app","portfolio"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/investments/[id]/index.tsx")
  },
  {
    name: "Liability",
    path: "liabilities/:id()",
    meta: { ...(indexouwRXwGeWJuIJmmt5tH4jT0Fly50oq600d38nrAEUuIMeta || {}), ...{"groups":["app","portfolio"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/liabilities/[id]/index.tsx")
  },
  {
    name: "portfolio-investments-id-communication",
    path: "investments/:id()/communication",
    props: true,
    meta: { ...(indexum9_45J_WCoYcDCcPycBO1D9LF_S5Xki4tF3_45TvWKWM9gMeta || {}), ...{"groups":["app","portfolio"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/investments/[id]/communication/index.tsx")
  },
  {
    name: "portfolio-investments-id-communication-communicationId",
    path: "investments/:id()/communication/:communicationId()",
    props: true,
    meta: { ...(indexk9gDfqBn3UkzMi82yV2lodgFZMCNrvj_45aAY5pFlolS0Meta || {}), ...{"groups":["app","portfolio"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/(portfolio)/portfolio/investments/[id]/communication/[communicationId]/index.tsx")
  }
]
  },
  {
    name: "Invites",
    path: "/settings/invites",
    meta: { ...(indexmbJ2NT0CQJZLagi8RIBcgNFpzduVNnjkJCkOWV24Jp8Meta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/invites/index.tsx")
  },
  {
    name: "Profile",
    path: "/settings/profile",
    meta: { ...(indexrkWvSxljdrEJ69pn_aByVkN8K0XEPD1fJz42qArexTQMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/profile/index.tsx")
  },
  {
    name: "Security & Password",
    path: "/settings/security",
    meta: { ...(indexMnOvNiwMglIw5HtmXqNexIR53LO6WH1zKg80lfGyuFYMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/security/index.tsx")
  },
  {
    name: "Investment Opportunity",
    path: "/opportunities/:id()",
    meta: { ...(indexVba0TN_IUX_EQHf1naPaalYADJMFzKqJ_K5m28tljGUMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/opportunities/[id]/index.tsx")
  },
  {
    name: "Graph & Snapshots",
    path: "/settings/snapshots",
    meta: { ...(indexar7XvJJCCj_457dXxugUcUbQRSk0t6HoC18TuzJGL6zmcMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/snapshots/index.tsx")
  },
  {
    name: "Providers & Integrations",
    path: "/settings/integrations",
    meta: { ...(indexuaCm7zaIxBxrcTjm0aaMeUVSf3bQGwtwEUhxpROUMx4Meta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/integrations/index.tsx")
  },
  {
    name: "settings-integrations-id",
    path: "/settings/integrations/:id()",
    meta: { ...(index2Uouy5ETjgfNcFSu9xvMDQ7IH_45VcklPtyTeuO5ySCUsMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/integrations/[id]/index.tsx")
  },
  {
    name: "Roles & Permissions",
    path: "/settings/company/:id()/roles",
    meta: { ...(indexqJowuk3dHU1QJ8D6zSwfmfKqhV2E5uRZAMLSaKEH9BMMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/company/[id]/roles/index.tsx")
  },
  {
    name: "Company Profile",
    path: "/settings/company/:id()/profile",
    meta: { ...(indexHfIArpVFJuR3jei5d9AS0xeCZcbPsHRCfnqbzDiemC8Meta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/company/[id]/profile/index.tsx")
  },
  {
    name: "IR Information",
    path: "/settings/company/:id()/ir-information",
    meta: { ...(indexbfYEXyYygzEFczTlRfW91luN_45yXoaKbjy9SUINogB2AMeta || {}), ...{"groups":["app"]} },
    component: () => import("/codebuild/output/src15932225/src/findex/apps/web-nuxt/pages/(app)/settings/company/[id]/ir-information/index.tsx")
  }
]